import { Link } from 'react-router-dom';

export default function BlogNav() {
  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 bg-[#0d0d0d]/95 backdrop-blur-sm border-b border-white/6"
      aria-label="Mason Hale Fitness — Blog navigation"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-4 flex items-center justify-between">
        <a
          href="https://masonhalefit.com"
          className="flex items-center gap-2 sm:gap-3 cursor-pointer"
          aria-label="Mason Hale Fitness — Return to homepage"
        >
          <div className="w-7 h-7 flex items-center justify-center bg-[#c8a96e] rounded-sm flex-shrink-0">
            <i className="ri-user-line text-black text-sm" aria-hidden="true" />
          </div>
          <span className="text-white font-black text-sm tracking-[0.22em] uppercase">
            Mason Hale
          </span>
        </a>

        <div className="hidden md:flex items-center gap-6">
          <Link
            to="/blog"
            className="text-gray-400 hover:text-white text-xs font-semibold tracking-[0.15em] uppercase transition-colors duration-200 whitespace-nowrap"
          >
            Blog
          </Link>
        </div>

        <a
          href="https://masonhalefit.com"
          className="inline-flex items-center gap-2 px-4 sm:px-5 py-2.5 bg-[#c8a96e] text-black text-xs font-black tracking-[0.15em] uppercase rounded-sm hover:bg-[#d9bc82] transition-all cursor-pointer whitespace-nowrap"
          aria-label="Get the Over-60 Strength Blueprint"
        >
          Get The Program
        </a>
      </div>
    </nav>
  );
}
